import { render, staticRenderFns } from "./RemoteControllerI18n.vue?vue&type=template&id=c92aaa02&scoped=true"
import script from "./RemoteControllerI18n.vue?vue&type=script&lang=js"
export * from "./RemoteControllerI18n.vue?vue&type=script&lang=js"
import style0 from "./RemoteControllerI18n.vue?vue&type=style&index=0&id=c92aaa02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92aaa02",
  null
  
)

export default component.exports